import React from 'react';
import dtController from './controller';

const DataTableContext = React.createContext();

// reducer
const reducer = (state, action) => {
  switch(action.type) {
    case 'constructController':
    return {
      ...state,
      controller: action.value,
    }
    case 'stateUpdate':
    return {
      ...state,
      dtState: {
        ...state.dtState,
        ...action.value,
      }
    }

    default: return state;
  }
};

// provider
const DataTableContextProvider = props => {

  const [state, dispatch] = React.useReducer(reducer, {
    dtState: {
      searchQuery: '',
      tableData: null,
      lastMemo: props.memo,
      refresh: 0,
    },
    controller: null,
  });

  const {controller, dtState} = state;

  // general state update
  const handleStateUpdate = obj => dispatch({type: 'stateUpdate', value: obj})

  // set constructor values for controller and add to state
  const setController = controllerInput => {
    dispatch({type: 'constructController', value: dtController({
      ...controllerInput,
      stateUpdate: handleStateUpdate,
      tableInstanceID: props.dataTableID,
    })})
  }

  // set parameter changes if fetchParamChange is set and clear group
  const handleFetchParamChange = param => {
    // console.log(param, props.fetchParamChange, "PROPS")
    state.controller.clearGroup();
    if (props.fetchParamChange) props.fetchParamChange(param);
  }

  // hide header func
  const handleHeaderPlacement = headerID => {
    controller.headerChange(headerID);
    controller.generateHeaders();
    controller.pagifyData();
    controller.render();
  }

  // refresh data sets after changes(memo should be the id of the data instance)
  const handleDataRefresh = memo => {
    if (props.dataRefresh) props.dataRefresh(memo);
    controller.page = 0;
    controller.data = null;
    // let initial render know this is not a hard refresh
    controller.refreshing = true;
    handleStateUpdate({tableData: null})
  }

  // keep data up to date with props.data
  const refreshTable = () => {
    controller.page = 0;
    handleStateUpdate({lastMemo: props.memo, tableData: null});
    // controller.updateStore.tableData = null;
    controller.filteredData = null;
    controller.searchingHeader = null;
    controller.queryString = '';
    controller.data = null;
    controller.sortIndex = {index: null, toBottom: false}
  }


  return(
    <DataTableContext.Provider
      value={{
        data: state.data,
        setController,
        controller: state.controller,
        handleStateUpdate: handleStateUpdate,
        dtState: state.dtState,
        handleFetchParamChange,
        handleHeaderPlacement,
        handleDataRefresh,
        refreshTable,
      }}
    >
      {props.children}
    </DataTableContext.Provider>
  )
}

const DataTableContextConsumer = DataTableContext.Consumer;

export {DataTableContext, DataTableContextProvider, DataTableContextConsumer};
